module.exports = __webpack_public_path__ + "img/step01_b_stand_power_open_box - Copy.62283134.png";